import { QueryClient, QueryClientProvider } from "react-query";
import { config } from "../../utils/conf";
import Loader from "react-loader-spinner";
import useGetImage from "../../hooks/useGetImage";
import store from "../../store";
import { Provider } from "react-redux";

const ImageContent = (props) => {
  const { mediaUrl, options, itemId } = props;

  const filteredItem =
    !mediaUrl && options?.find(({ rawData: { itemId } }) => itemId === itemId);

  const imageQuery = useGetImage(
    mediaUrl
      ? mediaUrl
      : filteredItem
      ? filteredItem.mediaUrl
      : `${config.rpcImagePath}default.png`,
    `${config.rpcImagePath}default.png`,
  );

  return (
    <>
      {!imageQuery.isFetching && (
        <img
          className="tw-object-contain tw-w-full tw-h-full"
          src={imageQuery.data}
          alt={itemId}
        />
      )}

      {imageQuery.isFetching && (
        <div
          className={
            "tw-absolute loader-container tw-inset-0 tw-flex tw-items-center tw-justify-center"
          }
        >
          <Loader
            type="ThreeDots"
            color="rgba(246,130,32,1)"
            height="50"
            width="50"
          />
        </div>
      )}
    </>
  );
};

const Wrapper = (props) => {
  const queryClient = new QueryClient();
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ImageContent {...props} />
      </QueryClientProvider>
    </Provider>
  );
};

export default Wrapper;
